import { showToastSuccess } from 'utils/toasts';
import api from './ApiAuthService';

export interface PaymentData {
  plan_id: number;
  token: string;
  description: string;
  installments: number;
  payment_method_id: string;
  // email: string;
}

export async function postCardToken(data: any): Promise<any> {
  try {
    const response = await api.post('/mercadopago/card-token', data);
    return response.data;
  } catch (error) {
    // throw new Error('Erro ao realizar a operação 5');
    // showToastSuccess('Erro ao realizar a operação: ' + error);
  }
}

export async function postPayment(data: PaymentData): Promise<any> {
  try {
    const response = await api.post('/mercadopago/payment', data);
    return response.data;
  } catch (error) {
    // console.error('Erro ao realizar o pagamento', error);
    // throw new Error('Erro ao realizar o pagamento');
  }
}

export async function getInstallments(data: any): Promise<any> {
  try {
    const response = await api.post('/mercadopago/installments', data);
    return response.data;
  } catch (error) {
    // console.error('Erro ao buscar as parcelas', error);
    // throw new Error('Erro ao buscar as parcelas');
  }
}

export async function getPaymentPix(data: any): Promise<any> {
  try {
    const response = await api.post('/mercadopago/create-pix', data);
    return response.data;
  } catch (error) {
    // console.error('Erro ao realizar o pagamento', error);
    // throw new Error('Erro ao realizar o pagamento');
  }
}

export async function getPaymentStatus(data: any): Promise<any> {
  try {
    const response = await api.post('/mercadopago/payment-status', data);
    return response.data;
  } catch (error) {
    // console.error('Erro ao realizar o pagamento', error);
    // throw new Error('Erro ao realizar o pagamento');
  }
}

export async function getPayment(data: any): Promise<any> {
  try {
    const response = await api.post('/mercadopago/get-payment', data);
    return response.data;
  } catch (error) {
    // console.error('Erro ao realizar o pagamento', error);
    // throw new Error('Erro ao realizar o pagamento');
  }
}
